



















































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { Timer } from '~/mixins';

@Component
export default class ProgressRing extends Mixins(Timer) {
  @Prop({ type: Number, default: 100 }) readonly progress!: number;
  @Prop({ type: String, default: '#2af1fd' }) color!: string;
  @Prop(String) colorVariable!: string;
  @Prop(Number) readonly size!: number;
  @Prop(Number) readonly strokeWidth!: number;
  @Prop(Boolean) readonly loaded!: boolean;
  @Prop(Boolean) readonly bgStroke!: boolean;
  @Prop(Boolean) readonly isTimer!: boolean;
  @Prop(Number) readonly endTime!: number;

  progressShown = this.progress;

  get radius() {
    return this.size / 2 - (this.strokeWidth * (this.bgStroke ? 1.8 : 1)) / 2;
  }

  get circumference() {
    return 2 * Math.PI * this.radius;
  }

  get center() {
    return this.size / 2;
  }

  get strokeDashoffset() {
    // return this.circumference - (this.progress / 100) * this.circumference;
    const offset = ((100 - this.progressShown) / 100) * this.circumference;
    return this.isTimer ? offset * -1 : offset;
  }

  get strokeColor() {
    return this.$vuetify.theme.currentTheme[this.colorVariable] || this.color;
  }

  get dimensions() {
    const size = `${this.size}px`;
    return {
      height: size,
      width: size,
    };
  }

  mounted() {
    if (this.isTimer && this.endTime) {
      this.beginTimer(this.endTime);
    }
  }

  @Watch('timerProgress')
  updateProgress(timerProgress: number) {
    this.progressShown = timerProgress;
  }
}
